<template>
  <div>
    <portal to="mobileMenuButton">
      <v-btn icon @click.prevent="$router.push('/cliente/' + $route.params.id)">
        <app-icon>navigate_before</app-icon>
      </v-btn>
    </portal>
    <CustomerBills ref="CustomerBills" :customer="customer" />
  </div>
</template>

<script>
import CustomerBills from "@/components/customers/sections/CustomerBills.vue";
export default {
  components: { CustomerBills },
  data: () => ({
    customer: {},
  }),

  created() {
    this.select();
  },

  methods: {
    async select() {
      this.$loading.start();

      await this.$http
        .show("customer/customer", this.$route.params.id)
        .then(async (response) => {
          this.customer = response.customer;
          this.$refs.CustomerBills.setCustomer(this.customer);
          await this.$refs.CustomerBills.select();
          this.$loading.finish();
        })
        .catch((error) => {
          this.$loading.finish();
        });
    },
  },
};
</script>

<style></style>
